module.exports = __webpack_public_path__ + "media/ui-payment-success.e551fd3d.mp3";